import { render } from "./ConfiguracionSidebar.vue?vue&type=template&id=5b9ad4ba"
import script from "./ConfiguracionSidebar.vue?vue&type=script&lang=js"
export * from "./ConfiguracionSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__